import { Search, CreditCard, Send } from "lucide-react";

const steps = [
  {
    number: "1",
    icon: Search,
    title: "Pilih Akun",
    description: "Cari & pilih akun premium favoritmu dari berbagai platform (Netflix, Spotify, dll).",
    color: "from-primary to-secondary",
  },
  {
    number: "2",
    icon: CreditCard,
    title: "Isi Data & Bayar QRIS",
    description: "Masukkan nomor WhatsApp, pilih jumlah, lalu bayar mudah & cepat via QRIS (semua e-wallet & mobile banking).",
    color: "from-secondary to-accent",
  },
  {
    number: "3",
    icon: Send,
    title: "Akun Dikirim Otomatis",
    description: "Setelah pembayaran terverifikasi, detail akun premium akan otomatis muncul & terupdate di invoice pembelianmu.",
    color: "from-accent to-primary",
  },
];

export function HowToOrderSection() {
  return (
    <section className="py-16 lg:py-24 gradient-hero">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Cara Order <span className="text-gradient">Mudah & Otomatis</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Hanya 3 langkah, akun premium langsung dikirim otomatis setelah pembayaran QRIS!
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative">
          {/* Connection line */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-primary via-secondary to-accent -translate-y-1/2 z-0" />

          {steps.map((step, index) => (
            <div
              key={step.title}
              className="relative z-10 text-center animate-fade-in"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="flex flex-col items-center">
                <div className={`w-20 h-20 rounded-full bg-gradient-to-br ${step.color} flex items-center justify-center mb-6 shadow-lg`}>
                  <step.icon className="h-10 w-10 text-primary-foreground" />
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full gradient-primary flex items-center justify-center text-primary-foreground font-bold text-sm shadow-md">
                  {step.number}
                </div>
              </div>
              <div className="bg-card p-6 rounded-2xl shadow-card">
                <h3 className="text-xl font-semibold mb-3">{step.title}</h3>
                <p className="text-sm text-muted-foreground">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
